<template>
    <div>
        <h1>Inicio Principal</h1>
    </div>
</template>

<script>
    export default {
        props: {
            datosSesion: Object
        }
    }
</script>